import React from "react";

const PaymentProcessingFee = ({
  currencySymbol, paymentProcessingFee,
}) => (
  <div>
    <span className="fees__donation-form-fee">
      <p>
        Payment processing fees:

      </p>
      <p className="fees__donation-form-amounts">
        {currencySymbol}
        {paymentProcessingFee}
      </p>
    </span>
  </div>
);

export default PaymentProcessingFee;
